
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";
import pxToRem from "assets/theme/functions/pxToRem";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(firstName, lastName, size, variant, border, cursor) {
  const notEmptyFirstName = firstName && firstName.trim();
  const notEmptyLastName = lastName && lastName.trim();
  const firstNameInitial = notEmptyFirstName && (notEmptyLastName ? notEmptyFirstName.split("")[0]?.toUpperCase() : notEmptyFirstName.slice(0, 2)?.toUpperCase());
  const lastNameInitial = notEmptyLastName && notEmptyLastName.split("")[0]?.toUpperCase();
  const { size: fontSize, fontWeightLight } = typography;
  const { borderWidth } = borders;
  const { white } = colors;
  let sizeValue;

  switch (size) {
    case "xxs":
      sizeValue = {
        width: pxToRem(30),
        height: pxToRem(30),
        fontSize: fontSize.xxs,
        borderRadius: pxToRem(30)
      };
      break;
    case "xs":
      sizeValue = {
        width: pxToRem(24),
        height: pxToRem(24),
        fontSize: fontSize.xs,
        borderRadius: pxToRem(24)
      };
      break;
    case "sm":
      sizeValue = {
        width: pxToRem(30),
        height: pxToRem(30),
        fontSize: fontSize.xxs,
        borderRadius: pxToRem(30)
      };
      break;
    case "lg":
      sizeValue = {
        width: pxToRem(60),
        height: pxToRem(60),
        fontSize: fontSize.xl,
        mr: pxToRem(10),
      };
      break;
    case "xl":
      sizeValue = {
        width: pxToRem(74),
        height: pxToRem(74),
        fontSize: fontSize.md,
      };
      break;
    case "xxl":
      sizeValue = {
        width: pxToRem(115),
        height: pxToRem(115),
        fontSize: pxToRem(45),
      };
      break;
    case "xxxl":
      sizeValue = {
        width: "100%",
        height: "100%",
        fontSize: pxToRem(25),
        borderRadius: "8px"
      };
      break;
    default: {
      sizeValue = {
        width: pxToRem(48),
        height: pxToRem(48),
        fontSize: fontSize.md,
      };
    }
  }
  return {
    sx: {
      cursor: cursor ? cursor : "unset",
      bgcolor: stringToColor(`${firstName} ${lastName}`),
      "&:hover": {
        backgroundColor: stringToColor(`${firstName} ${lastName}`),
      },
      border: border ? border : `${borderWidth[2]} solid ${white.main}`,
      fontWeight: fontWeightLight,
      color: 'white !important',
      ...sizeValue,
    },
    children: `${firstNameInitial}${lastNameInitial}`,
    variant: variant,
  };
}

export default function DefaultUserAvatar({
  firstName,
  lastName,
  email,
  size,
  variant,
  border,
  open,
  disableFocusListener,
  disableTouchListener,
  cursor,
  placement = "bottom",
  sx,
}) {
  const fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  const tooltipTitle = fullName || email || "";

  return (
    <Tooltip
      title={tooltipTitle}
      open={open}
      disableFocusListener={disableFocusListener}
      disableTouchListener={disableTouchListener}
      placement={placement}
    >
      <Avatar
        {...stringAvatar(firstName, lastName, size, variant, border, cursor)}
        sx={{
          ...stringAvatar(firstName, lastName, size, variant, border, cursor).sx,
          ...(typeof sx === "function" ? {} : sx)
        }}
      />
    </Tooltip>
  );
}
